import { API_BASE_URL } from '../constants';

/**
 * /api/public-config — fetched ONCE per page load and shared.
 *
 * App.js loads it on boot, and the search page, hotel detail, confirm booking,
 * flight detail, checkout modal, WebBeds booking form and both gateway helpers
 * each fetched it again on their own — three or four identical requests on
 * some pages, with prices first painted at 0% markup until "their" copy came
 * back. Everyone now awaits the same promise, and `peekPublicConfig()` gives
 * the already-loaded value synchronously for a first render with the right
 * numbers.
 *
 * A failed request is not cached, so the next caller retries. Admin screens
 * that must see a just-saved value keep calling the endpoint directly.
 */
let _promise = null;
let _value = null;

export function getPublicConfig() {
    if (!_promise) {
        _promise = fetch(`${API_BASE_URL}/api/public-config`)
            .then(r => {
                if (!r.ok) throw new Error(`public-config HTTP ${r.status}`);
                return r.json();
            })
            .then(cfg => {
                _value = cfg || {};
                // Same map the server puts in the HTML (utils/siteFeatures.js).
                // If the HTML didn't carry it, re-render once with it applied.
                if (typeof window !== 'undefined') {
                    const next = { ...(_value.suppliersReady || {}) };
                    if (_value.ratehawkReady === false) next.ratehawk = false;
                    const before = JSON.stringify(window.__HM_SUPPLIERS__ || {});
                    window.__HM_SUPPLIERS__ = { ...(window.__HM_SUPPLIERS__ || {}), ...next };
                    if (JSON.stringify(window.__HM_SUPPLIERS__) !== before) {
                        try { window.dispatchEvent(new Event('hm-settings-loaded')); } catch { /* old browsers */ }
                    }
                }
                return _value;
            })
            .catch(err => { _promise = null; throw err; });
    }
    return _promise;
}

/** The loaded config, or null if it hasn't arrived yet. */
export function peekPublicConfig() {
    return _value;
}
